import React from 'react'
import { Form, Button, Skeleton } from 'antd'

export default function SubmitButton (props) {
    if (props.isLoading) {
        return ( <Skeleton.Button active="false" size={props.size}/> )
    }

    const tailLayout = { wrapperCol: { span: 24 } };
    
    return (
        <Form.Item {...tailLayout} 
            style={{marginTop:"16px"} } 
            >
            <Button 
                className="sign-in-button" 
                loading={props.isDoingAction} 
                type="primary" htmlType="submit"
                disabled={props.disabled}
            >
            {props.isDoingAction ? props.loadingText : props.originalText} 
            </Button>
        </Form.Item>
    )
}